import type { RecallDetails } from '../api/types'
import { formatDate, formatNumber } from '../domain/format'
import { DataRows } from './Section'
import { rows } from '../domain/rows'

/**
 * Manufacturer recalls, newest first.
 *
 * A recall is the one part of the report somebody may need to act on, so each one is a card of its
 * own rather than a row in a table: the hazard and the repair have to be readable, not truncated.
 */
export function RecallList({ recalls }: { recalls: RecallDetails[] }) {
  return (
    <>
      {recalls.map((recall) => (
        <article className="recall" key={recall.referenceCode}>
          <header className="recall__header">
            <h3 className="recall__title">{recall.defectDescription ?? 'Terugroepactie'}</h3>
            <span className="recall__reference">{recall.referenceCode}</span>
          </header>

          <DataRows
            items={rows(
              { label: 'Status', value: recall.status },
              { label: 'Categorie', value: recall.defectCategory },
              { label: 'Gemeld door', value: recall.reportedBy },
              { label: 'Gevolgen', value: recall.consequences },
              { label: 'Mogelijk gevaar', value: recall.potentialHazard },
              { label: 'Risico-inschatting', value: recall.riskAssessment },
              { label: 'Herstel', value: recall.repairDescription },
              { label: 'Eigenaren geïnformeerd via', value: recall.ownerNotificationMethods?.join(', ') },
              { label: 'Aangekondigd op', value: formatDate(recall.announcedOn) },
              { label: 'Gepubliceerd op', value: formatDate(recall.publishedOn) },
              { label: 'Eigenaren geïnformeerd op', value: formatDate(recall.ownersInformedOn) },
              { label: "Voertuigen wereldwijd", value: formatNumber(recall.vehiclesAffectedTotal) },
              { label: 'Voertuigen in Nederland', value: formatNumber(recall.vehiclesAffectedNetherlands) },
              { label: 'Telefoonnummer', value: recall.moreInformationPhoneNumber },
              {
                label: 'Meer informatie',
                value: recall.moreInformationUrl ? (
                  <a href={recall.moreInformationUrl} target="_blank" rel="noreferrer noopener">
                    {recall.moreInformationUrl}
                  </a>
                ) : undefined,
              },
              { label: 'Opmerkingen', value: recall.remarks },
            )}
          />
        </article>
      ))}
    </>
  )
}
